import { API_CACHE_KEY } from '../services/api/accountsApi/keys';
import { RESET_ACCOUNTS } from './actionTypes';

const resetAccounts = () => ({ type: RESET_ACCOUNTS, metadata: { abortRequestsCacheKey: API_CACHE_KEY } });

export default resetAccounts;
